export const locales: {
  key: HrefLang;
  label: string;
  longCode?: HrefLang;
  flagUrl: string;
}[] = [
  { key: "en", label: "English", flagUrl: "https://flagcdn.com/16x12/us.png" },
  {
    key: "nb",
    label: "Bokmål",
    longCode: "nb-NO",
    flagUrl: "https://flagcdn.com/16x12/no.png",
  },
  {
    key: "nn",
    label: "Nynorsk",
    longCode: "nn-NO",
    flagUrl: "https://flagcdn.com/16x12/no.png",
  },
  {
    key: "sv",
    label: "Svenska",
    longCode: "sv-SE",
    flagUrl: "https://flagcdn.com/16x12/se.png",
  },
  {
    key: "da",
    label: "Dansk",
    longCode: "da-DK",
    flagUrl: "https://flagcdn.com/16x12/dk.png",
  },
];
